export const normalizeEnum = (value) =>
  (value ?? "").toString().toUpperCase().replace(/[\s-]/g, "_");

export const STATUS_GROUPS = {
  PENDING: "PENDING",
  PROCESSING: "PROCESSING",
  PAST: "PAST",
};

const GROUP_BY_STATUS = {
  PENDING: STATUS_GROUPS.PENDING,
  ACCEPTED: STATUS_GROUPS.PROCESSING,
  DISPATCHED: STATUS_GROUPS.PROCESSING,
  DELIVERED: STATUS_GROUPS.PAST,
  CANCELLED: STATUS_GROUPS.PAST,
  DECLINED: STATUS_GROUPS.PAST,
  REJECTED: STATUS_GROUPS.PAST,
  RETURNED: STATUS_GROUPS.PAST,
  REFUNDED: STATUS_GROUPS.PAST,
};

export const groupForStatus = (status) =>
  GROUP_BY_STATUS[normalizeEnum(status)] || null;

const BADGES = {
  ACCEPTED: { label: "IN PROGRESS", tone: "active" },
  DISPATCHED: { label: "Dispatched", tone: "active" },
  DELIVERED: { label: "Delivered", tone: "success" },
  RETURNED: { label: "Returned", tone: "neutral" },
  REFUNDED: { label: "Refunded", tone: "active" },
  CANCELLED: { label: "Cancelled", tone: "danger" },
  DECLINED: { label: "Declined", tone: "danger" },
  REJECTED: { label: "Rejected", tone: "danger" },
};

export const badgeForStatus = (status) => BADGES[normalizeEnum(status)] || null;

const ACTIVE_RANK = {
  PENDING: 0,
  ACCEPTED: 1,
  DISPATCHED: 2,
  DELIVERED: 3,
};

export const slowestStatus = (statuses) => {
  const normalized = (statuses || []).map(normalizeEnum).filter(Boolean);

  if (!normalized.length) return null;

  const active = normalized.filter((status) => status in ACTIVE_RANK);

  if (!active.length) return normalized[0];

  return active.reduce((slowest, status) =>
    ACTIVE_RANK[status] < ACTIVE_RANK[slowest] ? status : slowest
  );
};

export const commonValue = (values) => {
  const present = (values || []).filter(
    (value) => value !== null && value !== undefined && value !== ""
  );

  if (!present.length) return null;

  return present.every((value) => value === present[0]) ? present[0] : null;
};

export const isRatable = (status) =>
  ["DELIVERED", "COMPLETED"].includes(normalizeEnum(status));
